import { assessmentApi } from "@/api/assessment.api";
import { participationV1Api } from "@/api/participationV1.api";
import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import type { MaybeRef } from "vue";

export function useCandidateAssessmentsV4() {
  return useQuery({
    queryKey: ['candidate-assessments', 'v4'],
    queryFn: () => assessmentApi.getCandidateAssessmentsV4(),
  });
}

export function useAssessmentTracking(participantId: MaybeRef<string>) {
  return useQuery({
    queryKey: ['assessment-tracking', participantId],
    queryFn: () => assessmentApi.getTracking(toValue(participantId)),
    enabled: computed(() => !!toValue(participantId)),
  });
}

export function useCompleteParticipation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (participationId: string) => participationV1Api.complete(participationId),
    onSuccess: (_, participationId) => {
      queryClient.invalidateQueries({ queryKey: ['candidate-assessments', 'v4'] });
      queryClient.invalidateQueries({ queryKey: ['assessment-tracking', participationId] });
    },
  });
}
